import React from "react";
import { Line } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);
const LineChart = ({
  numbers,
  date,
  color,
  bgColor,
  pointColor,
  title,
  karaokeColor,
  karaokeBgColor,
  karaokePointColor,
}) => {
  const data = {
    labels: date,
    datasets: [
      {
        data: numbers,
        fill: true,
        borderColor: "#" + color,
        backgroundColor: "#" + bgColor + "33",
        tension: 0.5,
        // datasetIndex: 0,
        pointStyle: "circle", // You can use "circle", "triangle", "rect", etc.
        pointRadius: 5, // Set the radius of the dots
        pointBackgroundColor: "#" + pointColor,
        pointBorderColor: "#ffffff",
        borderWidth: 3,
      },
      // {
      //    data: [23000, 33023, 25030, 35006, 51001, 54020, 76450, 60012, 50000, 97000, 80000, 72000],
      //    fill: true,
      //    borderColor: "rgba(58, 111, 248, 1)",
      //    backgroundColor: "rgba(58, 111, 248, 0.2)",
      //    tension: 0.5,
      //    //   datasetIndex: 0,
      // },
    ],
  };
  function formatNumberToK(value) {
    if (Math.abs(value) >= 1000000) {
      // If the number is in millions or greater, format it with M (million)
      return (value / 1000000).toFixed(1) + "M";
    } else if (Math.abs(value) >= 1000) {
      // If the number is in thousands or greater, format it with K (thousand)
      return (value / 1000).toFixed(1) + "K";
    } else {
      // Otherwise, leave the number as is
      return value.toString();
    }
  }
  // const options = {
  //    responsive: true, // Allow the chart to be responsive
  //    maintainAspectRatio: false, // Disable the aspect ratio calculation
  //    plugins: {
  //       legend: {
  //          display: false,
  //       },
  //       tooltip: {
  //          displayColors: false,
  //          backgroundColor: colorItems,
  //          yAlign: "bottom",
  //          padding: 10,
  //          callbacks: {
  //             title: () => "Сонсолтын тоо",
  //          },
  //          titleAlign: "center",
  //          titleFont: {
  //             size: 12,
  //          },
  //          bodyFont: {
  //             size: 16,
  //             weight: "bold",
  //          },
  //          bodyAlign: "center",
  //       },
  //    },
  //    scales: {
  //       y: {
  //          beginAtZero: true,
  //          ticks: {
  //             stepSize: 20000,
  //          },
  //          grid: {
  //             color: "#E5E7EB",
  //          },
  //       },
  //       x: {
  //          grid: {
  //             display: false,
  //          },
  //       },
  //    },
  // };
  const options = {
    responsive: true, // Allow the chart to be responsive
    maintainAspectRatio: false, // Disable the aspect ratio calculation
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        displayColors: false,
        backgroundColor: "#" + pointColor,
        yAlign: "bottom",
        padding: 10,
        callbacks: {
          title: () => title,
        },
        titleAlign: "center",
        titleFont: {
          size: 12,
        },
        bodyFont: {
          size: 16,
          weight: "bold",
        },
        bodyAlign: "center",
      },
      plugins: {
        datalabels: {
          formatter: function (context) {
            return context / 1000 + "k";
          },
        },
      },
    },
    scales: {
      y: {
        border: { dash: [8, 8] }, // for the grid lines
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            return formatNumberToK(value);
          },
        },
        grid: {
          color: "#E5E7EB",
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
  };
  return (
    <div className="h-full w-full">
      <Line data={data} options={options} />
    </div>
  );
};

export default LineChart;
